import { useCheckRelations } from "components/common";
import { AuthEnums } from "models/enums";
import useAdvisorPermissions from "../usePermissions";

function useHoldingRegisterPermissions() {
  const { isAdvisor } = useAdvisorPermissions();
  const { getIsRevisor, hasRelation } = useCheckRelations();
  const hasHoldingRegisterAvailable =
    isAdvisor || getIsRevisor() || hasRelation(AuthEnums.PersonCompanyRelationType.Reports);

  return { hasHoldingRegisterAvailable };
}

export default useHoldingRegisterPermissions;
